export const latestAddresses = [
  {
    id: 'addr-1',
    url: 'https://www.91n.con',
    label: '官方主站',
    status: 'online',
    description: '91n.con 官方主域名入口，推荐优先使用',
    updatedAt: '2026-08-05 09:30',
    speed: '极快',
    region: '全球',
  },
  {
    id: 'addr-2',
    url: 'https://91n.con/mirror',
    label: '官方镜像一',
    status: 'online',
    description: '高可用镜像节点，主站负载均衡',
    updatedAt: '2026-08-05 09:28',
    speed: '快',
    region: '亚洲',
  },
  {
    id: 'addr-3',
    url: 'https://mirror.91n.con',
    label: '官方镜像二',
    status: 'online',
    description: '备用访问通道，自动故障转移',
    updatedAt: '2026-08-05 09:25',
    speed: '快',
    region: '亚洲优化',
  },
  {
    id: 'addr-4',
    url: 'https://cn.91n.con',
    label: '大陆优化节点',
    status: 'online',
    description: '针对中国大陆用户优化的专属节点',
    updatedAt: '2026-08-05 09:20',
    speed: '较快',
    region: '中国大陆',
  },
  {
    id: 'addr-5',
    url: 'https://hk.91n.con',
    label: '港澳台节点',
    status: 'online',
    description: '面向港澳台地区用户的高速入口',
    updatedAt: '2026-08-05 09:15',
    speed: '极快',
    region: '港澳台',
  },
  {
    id: 'addr-6',
    url: 'https://us.91n.con',
    label: '海外节点',
    status: 'online',
    description: '面向海外用户的英文界面入口',
    updatedAt: '2026-08-05 09:10',
    speed: '快',
    region: '海外',
  },
];

export const howToAccess = [
  {
    step: 1,
    title: '选择入口地址',
    description: '从上方地址列表中选择适合您所在地区的官方入口链接',
    icon: 'ri-links-line',
  },
  {
    step: 2,
    title: '点击访问',
    description: '直接点击链接或复制到浏览器地址栏打开目标页面',
    icon: 'ri-cursor-line',
  },
  {
    step: 3,
    title: '收藏备用',
    description: '将本页添加到浏览器书签，方便下次快速找到最新地址',
    icon: 'ri-bookmark-line',
  },
  {
    step: 4,
    title: '关注更新',
    description: '定期访问本页面获取最新可用地址与官方公告',
    icon: 'ri-notification-3-line',
  },
];

export const features = [
  {
    id: 'feat-1',
    icon: 'ri-shield-check-line',
    title: '官方认证',
    description: '所有地址均来自91n.con官方发布渠道，经过严格验证确保真实可靠',
  },
  {
    id: 'feat-2',
    icon: 'ri-refresh-line',
    title: '实时更新',
    description: '地址信息保持与官方同步更新，您看到的永远是最新可用入口',
  },
  {
    id: 'feat-3',
    icon: 'ri-speed-mini-line',
    title: '智能路由',
    description: '根据您的地理位置自动推荐最优访问节点，获得最佳访问速度',
  },
  {
    id: 'feat-4',
    icon: 'ri-question-answer-line',
    title: '全面解答',
    description: '覆盖访问、注册、使用等各方面的常见问题，一站式解决您的疑问',
  },
];

export const stats = [
  { value: '500万+', label: '月活跃用户' },
  { value: '99.9%', label: '服务可用率' },
  { value: '50+', label: '全球节点' },
  { value: '24/7', label: '技术支持' },
];